import { combineReducers } from "redux";
import { ClaimDetailsReducer, fetch_Claim_List_Reducer, UploadedMedicalIRDocs } from "./reducers/claimDetailsReducer";
import userLogin from "./reducers/userLogin";
import { chequeDetailsRed, kycDetailsRed, kycUploadDetailsRed, panDetailsRed, selfieDetailsRed } from "./reducers/kycDetailsReducer";
import VerifyBankReducer from "./reducers/VerifyBankReducer";
import ssoLoginReducer from "./reducers/ssoLoginReducer";
import {
  fetch_Beneficiaries_And_Policy_Details_Reducer,
  fetch_ActiveClaims_Details_Reducer,
  fetch_ActiveIntimation_Details_Reducer,
  fetch_Enrolments_Details_Reducer,
  fetch_Health_Benefits_Reducer,
  fetch_Health_Check_Partner_Services_Reducer,
  fetch_Vendor_Url_Reducer,
  fetch_Flex_Policies_Reducer,
  fetch_Corporate_Config_Reducer} from './reducers/homeDetailsReducer';
import { fetch_Bank_Details_Reducer, fetch_Kyc_Reducer, fetch_Si_Protect_Reducer,fetch_base_profile_Details_Reducer,fetch_config_Details_Reducer } from "./reducers/accountDetailsReducer";
import { fetch_MemberConfig_Reducer, fetch_MemberdomiBalance_Reducer } from "./reducers/memberDetailsReducer";
import { getClaims, getProfile } from "../modules/node20/reducers/store";
import { appConfigReducer } from "./store/appConfigReducer";

const MainReducer = combineReducers({
  BankDetails: VerifyBankReducer,
  ClaimDetails: ClaimDetailsReducer,
  MedicalDocs: UploadedMedicalIRDocs,
  KYCDetails: kycDetailsRed,
  userLoginDetails: userLogin,
  SelfieDetails: selfieDetailsRed,
  PANDetails: panDetailsRed,
  ChequeDetails: chequeDetailsRed,
  ssoLoginDetails: ssoLoginReducer,
  fetch_Beneficiaries_And_Policy_Details: fetch_Beneficiaries_And_Policy_Details_Reducer,
  kycUploadDetails:kycUploadDetailsRed,
  fetch_base_profile_Details:fetch_base_profile_Details_Reducer,
  fetch_config_Details:fetch_config_Details_Reducer,
  fetch_Si_Protect:fetch_Si_Protect_Reducer,
  fetch_Kyc_Details:fetch_Kyc_Reducer,
  fetch_bank_Details:fetch_Bank_Details_Reducer,
  fetch_ActiveClaims_Details:fetch_ActiveClaims_Details_Reducer,
  fetch_ActiveIntimation_Details:fetch_ActiveIntimation_Details_Reducer,
  fetch_Enrolments_Details:fetch_Enrolments_Details_Reducer,
  fetch_MemberConfig_Details:fetch_MemberConfig_Reducer,
  fetch_MemberdomiBalance_Details:fetch_MemberdomiBalance_Reducer,
  fetch_ClaimList_Details:fetch_Claim_List_Reducer,
  fetch_health_benefits:fetch_Health_Benefits_Reducer,
  fetch_HealthCheck_Services:fetch_Health_Check_Partner_Services_Reducer,
  fetch_Vendor_Url_Services:fetch_Vendor_Url_Reducer,
  fetch_Flex_Policies: fetch_Flex_Policies_Reducer,
  fetch_Corporate_Config : fetch_Corporate_Config_Reducer,
  getProfile : getProfile,
  getClaims: getClaims,
  appConfig: appConfigReducer,
});

const rootReducer = (state: RootState | undefined, action: any) => {
  if (action.type === 'LOGOUT') {
    const appConfig = state?.appConfig;

    // Reset entire state
    const newState = MainReducer(undefined, action);

    // Restore appConfig
    return {
      ...newState,
      appConfig,
    };
  }

  return MainReducer(state, action);
};


export type RootState = ReturnType<typeof MainReducer>;

export default rootReducer;
export type rootReducer =ReturnType<typeof rootReducer> 